import { useState } from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment/moment'
import { FiAlertCircle } from 'react-icons/fi'
import { Form, Formik } from 'formik'

import { Modal } from 'Components/Ui'
import { Button, TextInput } from 'Components/Form'
import Accept from 'Views/Admin/Pickups/Accept'

export default function ConfirmationModal({
    children,
    data,
    validation,
    onConfirm,
    title = '',
    message = '',
    className = '',
    maxWidth = 'md',
}) {
    const [confirming, setConfirming] = useState(false)

    const { affiliates, storages } = useSelector(state => state.admin.list)

    const closeModal = () => setConfirming(false)
    const handleOpen = () => setConfirming(true)

    const submit = (values, { setSubmitting }) => {
        setSubmitting(true)
        closeModal()
        onConfirm(values)
        setSubmitting(false)
    }

    return (
        <div>
            <button type="button" className={className} onClick={handleOpen}>
                {children}
            </button>
            <Modal show={confirming} onClose={closeModal} maxWidth={maxWidth}>
                <Formik initialValues={data || {}} validationSchema={validation} onSubmit={submit}>
                    {({ values, touched, errors, isSubmitting, setFieldValue }) => (
                        <Form className="grid gap-3 p-6 text-center">
                            <span className="inline-block mx-auto">
                                <div className="flex items-center justify-center w-20 h-20 transition rounded-full bg-warning/10 text-warning">
                                    <FiAlertCircle size={40} />
                                </div>
                            </span>
                            <h3 className="text-xl font-bold text-black dark:text-white sm:text-2xl">
                                {title ? title : 'Confirmation Alert!'}
                            </h3>
                            <p className="font-medium">{message ? message : 'Are you sure you want to change status?'}</p>
                            {'expected_delivery_date' in values && (
                                <div className="flex flex-col gap-3 text-left">
                                    <TextInput
                                        type="date"
                                        id="expected_delivery_date"
                                        name="expected_delivery_date"
                                        label="Expected Delivery Date"
                                        min={moment().format('YYYY-MM-DD')}
                                        error={touched?.expected_delivery_date && errors?.expected_delivery_date}
                                    />
                                </div>
                            )}
                            {'manifest_no' in values && (
                                <div className="flex flex-col gap-3 text-left">
                                    <Accept
                                        values={values}
                                        touched={touched}
                                        errors={errors}
                                        setFieldValue={setFieldValue}
                                        affiliates={affiliates}
                                        storages={storages}
                                    />
                                </div>
                            )}
                            <div className="grid grid-cols-1 gap-3 pt-5 md:grid-cols-2">
                                <Button type="button" className="w-full text-white border-danger bg-danger" onClick={closeModal}>
                                    No
                                </Button>
                                <Button
                                    className="w-full text-white border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                    disabled={isSubmitting}
                                    type="submit"
                                >
                                    Yes
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal>
        </div>
    )
}
